;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();export const copyTextToClipboard = (text: string): void => {
  if ('clipboard' in navigator) {
    navigator.clipboard.writeText(text);
  } else {
    document.execCommand('copy', true, text);
  }
};

export const goToExternalUrl = (url: string, openInNewTab = true): void => {
  const anchor = document.createElement('a');

  document.body.appendChild(anchor);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  anchor.style = 'display: none';
  anchor.href = url;

  if (openInNewTab) {
    anchor.target = '_blank';
  }

  anchor.click();
  document.body.removeChild(anchor);
};

export const dispatchGlobalEvent = (
  eventName: string,
  {
    bubbles = false,
    cancelable = false,
    detail = undefined,
    composed = false,
  }: CustomEventInit<unknown> = {},
): CustomEvent => {
  let event;

  if (typeof window.Event === 'function') {
    event = new window.CustomEvent(eventName, {
      bubbles,
      cancelable,
      composed,
      detail,
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, bubbles, cancelable, detail);
  }

  window.dispatchEvent(event);

  return event;
};
